import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import productImg from "../assets/img/product/product_1_1.jpg";
import productThumbImg from "../assets/img/product/product_thumb_1_1.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "./layout";

export default function Home() {
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";
  const [products, setProducts] = useState([]);
  const history = useHistory();
  const [selectedOption, setSelectedOption] = useState([]);
  const [rentalStartDate, setRentalStartDate] = useState(new Date());
  const [rentalEndDate, setRentalEndDate] = useState(new Date());
  const [showOptions, setShowOptions] = useState(false); // New state to control visibility
  const [selectedAction, setSelectedAction] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isInCart, setIsInCart] = useState(false); // New state
  const [cartItemDetails, setCartItemDetails] = useState(null); // New state

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API_URL}/products`);
      setProducts(res.data);
    } catch (error) {
      console.error("Failed to fetch products:", error);
      setProducts([]);
    }
  };
  const handleProductClick = (id) => {
    localStorage.setItem("product_id", id);
    history.push("/view");
  };

  const handleAddToWishlist = (id) => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      Swal.fire(
        "Login Required",
        "Please login to proceed to wishlist.",
        "info"
      );
      return;
    }
    const product_details = products.find((product) => product.id === id);
    if (!product_details) return;
    if (selectedOption === "buy" && quantity > product_details.saleStock) {
      Swal.fire("Error", "Not enough stock available for purchase.", "error");
      return;
    }
    if (selectedOption === "rent" && product_details.rentalStock <= 0) {
      Swal.fire("Error", "Not enough stock available for rent.", "error");
      return;
    }

    const timeDiff = rentalEndDate.getTime() - rentalStartDate.getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const rentalDays = diffDays > 0 ? diffDays : 1;

    const cartItem = {
      productId: product_details.id,
      name: product_details.name,
      price: product_details.salePrice,
      quantity: selectedOption === "buy" ? quantity : rentalDays,
      type: selectedOption,
      image: product_details.image,
    };

    if (selectedOption === "rent") {
      cartItem.rentalStartDate = rentalStartDate.toISOString();
      cartItem.rentalEndDate = rentalEndDate.toISOString();
    }

    //    // Get existing cart items from localStorage
    const userId = localStorage.getItem("currentUserId");
    const wishlistKey = `wishlist_${userId}`;
    const existingCart = JSON.parse(localStorage.getItem(wishlistKey) || "[]");

    //    // Check if item already exists in cart
    const existingItemIndex = existingCart.findIndex(
      (item) =>
        item.productId === cartItem.productId && item.type === cartItem.type
    );

    if (existingItemIndex > -1) {
      // Update quantity if item exists
      existingCart[existingItemIndex].quantity += cartItem.quantity;
    } else {
      // Add new item if it doesn't exist
      existingCart.push(cartItem);
    }

    //    // Save updated cart to localStorage
    const updatedCart = existingCart;
    localStorage.setItem(wishlistKey, JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated")); // Dispatch event
    history.push("/wishlist"); // Navigate to wishlist page

    Swal.fire({
      title: "Success!",
      text: "Product added to wishlist",
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
    });
    setShowOptions(false); // Hide options after adding to cart
    setQuantity(1); // Reset quantity
    setRentalStartDate(new Date());
    setRentalEndDate(new Date());
    setSelectedOption("buy"); // Reset option
    setSelectedAction(null); // Reset selected action
    setIsInCart(true); // Update cart status
    setCartItemDetails(cartItem); // Update cart item details
  };

  useEffect(() => {
    fetchProducts();
  }, []);
  return (
    <>
      {/* <div className="color-scheme-wrap active">
        <button className="switchIcon">
          <i className="fa-solid fa-palette"></i>
        </button>
        <h4 className="color-scheme-wrap-title">
          <i className="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div className="color-switch-btns">
          <button data-color="#3E66F3">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i className="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          className="th-btn text-center w-100"
        >
          <i className="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div> */}
      {/* <div className="preloader ">
        <button className="th-btn preloaderCls">Cancel Preloader </button>
        <div className="preloader-inner">
          <img src="assets/img/logo.svg" alt="img" />
          <div className="heart-rate">
            <img src="assets/img/shape/preloader.svg" alt="" />

            <div className="fade-in"></div>

            <div className="fade-out"></div>
          </div>
        </div>
      </div> */}
      <div id="QuickView" className="white-popup mfp-hide">
        <div className="container bg-white">
          <div className="row gx-60">
            <div className="col-lg-6">
              <div className="product-big-img">
                <div className="img">
                  <img src={productImg} alt="Product Image12" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="product-about">
                <p className="price">
                   ₹25.00 USD <del> ₹28.00 USD</del>
                </p>
                <h2 className="product-title">Fingertip Pulse Oximeter</h2>
                <div className="product-rating">
                  <div
                    className="star-rating"
                    role="img"
                    aria-label="Rated 5.00 out of 5"
                  >
                    <span style={{ width: "100%" }}>
                      Rated <strong className="rating">5.00</strong> out of 5
                      based on <span className="rating">1</span> customer rating
                    </span>
                  </div>
                  <Link
                    to="shop-details.html"
                    className="woocommerce-review-link"
                  >
                    (<span className="count">3</span> customer reviews)
                  </Link>
                </div>
                <p className="text">
                  A device for measuring blood pressure is a medical device that
                  helps individuals monitor their blood pressure levels at home.
                  The user places the cuff on their arm, presses a button to
                  inflate it, and the device measures the pressure in the
                  arteries as the cuff slowly deflates.
                </p>
                <div className="checklist style4">
                  <ul>
                    <li>
                      {" "}
                      <i className="fa-regular fa-ship fa-fw"></i>Estimate
                      delivery times: 12-26 days (International), 3-6 days
                      (United States).
                    </li>
                    <li>
                      <i className="fa-solid fa-rotate-left"></i>Return within 7
                      days of purchase. Duties & taxes are non-refundable.
                    </li>
                  </ul>
                </div>
                <div className="actions">
                  <div className="quantity">
                    <input
                      type="number"
                      className="qty-input"
                      step="1"
                      min="1"
                      max="100"
                      name="quantity"
                      value="1"
                      title="Qty"
                    />
                    <button className="quantity-plus qty-btn">
                      <i className="far fa-chevron-up"></i>
                    </button>
                    <button className="quantity-minus qty-btn">
                      <i className="far fa-chevron-down"></i>
                    </button>
                  </div>
                  <button className="th-btn">Add to Cart</button>
                </div>
                <div className="product_meta">
                  <span className="sku_wrapper">
                    SKU: <span className="sku">Medical-1254</span>
                  </span>
                  <span className="posted_in">
                    Category:{" "}
                    <Link to="shop.html" rel="tag">
                      Device, Heatlhcare
                    </Link>
                  </span>
                  <span>
                    Tags: <Link to="shop.html">Medical Device</Link>
                  </span>
                  <span>
                    Availability: <Link to="shop.html">In Stock: 25</Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button title="Close (Esc)" type="button" className="mfp-close">
            ×
          </button>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper shopping-cart ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget woocommerce widget_shopping_cart">
            <h3 className="widget_title">Shopping cart</h3>
            <div className="widget_shopping_cart_content">
              <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img src={productThumbImg} alt="Cart Image1" />
                    Puregen Labs Meclizine
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image12"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image3"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image4"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image6"
                    />
                    Digital Thermometer
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p className="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  170.99
                </span>
              </p>
              <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" className="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" className="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget footer-widget mb-0">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="index.html">
                  <img src="assets/img/sunrise_logo.png" alt="Sunrise " />
                </Link>
              </div>
              <p className="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image8"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 02, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image9"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 25, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image10"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image11"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Social Media:</h3>
            <div className="th-social">
              <Link to="https://www.facebook.com/people/Shreeji-Medical-Instrument-Sales-Service/61575696639548/">
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link
                to="https://www.google.com/search?q=Shreeji+Medical+Instrument+Sales+%26+Service&stick=H4sIAAAAAAAA_-NgU1I1qDC2NE21MDVLSzMzMExLTjG3MqiwME41SDE0NzQ2NrAwMEtKXcSqFZxRlJqalangm5qSmZyYo-CZV1xSVJqbmleiEJyYk1qsoKYQnFpUlpmcCgBlmDQtVgAAAA&hl=en-GB&mat=CZj-idQTNBWkElYBYJahadvTbgNOBBH5HW1MU06y9r9odX3imjI0NWI-9CbfJQa7sUcGnLDl5gJbZOQiigv041kUAYfNDnQeEN8kKDcHtyhwLxeSFpSK7u1waBCv2V8n4A&authuser=0
"
              >
                <i className="fab fa-google" />
              </Link>
              <Link
                to="https://www.instagram.com/shreejimedicalinstrument/
"
              >
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="home-medical-clinic.html">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="/">Home</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">
                          Home Dental Care
                        </Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">
                          Home Cardiology
                        </Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">
                          Home Optometrist
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">
                      Case Studies Details
                    </Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Layout>
        <>
          <div
            className="swiper th-slider"
            data-slider-options='{"effect":"fade"}'
          >
            <div className="hero-slider-wrapper">
              <>
                <Swiper
                  modules={[Navigation, Pagination]}
                  navigation={{
                    nextEl: ".custom-next", // 👈 match class
                    prevEl: ".custom-prev", // 👈 match class
                  }}
                  pagination={{ clickable: true }}
                  loop={true}
                  className="hero-swiper"
                >
                  <SwiperSlide>
                    <div className="hero-inner">
                      <div className="container">
                        <div className="hero-slide-area">
                          <div className="row align-items-center">
                            <div className="col-xl-7">
                              <div className="hero-style9">
                                <span
                                  className="sub-title style3"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.2s"
                                >
                                  Up To 50% Off Today Only!
                                </span>
                                <h1
                                  className="hero-title"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.4s"
                                >
                                  Gold Standard <br /> Pre-Workout
                                </h1>
                                <p
                                  className="hero-text"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.6s"
                                >
                                  Starting at &amp;16.99
                                </p>
                                <div
                                  className="btn-group justify-content-xl-start justify-content-center"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.6s"
                                >
                                  <Link
                                    to="/shop"
                                    className="th-btn style4 th-radius2"
                                  >
                                    <i className="fa-solid fa-cart-shopping me-2"></i>
                                    Shop Now
                                  </Link>
                                </div>
                              </div>
                            </div>

                            <div className="col-xl-5">
                              <div
                                className="hero-image"
                                data-ani="slideinup"
                                data-ani-delay="0.4s"
                              >
                                <img
                                  // src="assets/img/hero/hero-9-2.png"
                                  src="assets/img/image1.jpg"
                                  alt="img"
                                  className="hero-img-fluid"                                
                                />
                                {/*
                                 */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="hero-inner">
                      <div className="container">
                        <div className="hero-slide-area">
                          <div className="row align-items-center">
                            <div className="col-xl-7">
                              <div className="hero-style9">
                                <span
                                  className="sub-title style3"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.2s"
                                >
                                  Welcome to our shop
                                </span>
                                <h1
                                  className="hero-title"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.4s"
                                >
                                  TGold Standard <br /> Pre-Workout
                                </h1>
                                <p
                                  className="hero-text"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.6s"
                                >
                                  Starting at &amp;16.99
                                </p>
                                <div
                                  className="btn-group justify-content-xl-start justify-content-center"
                                  data-ani="slideinleft"
                                  data-ani-delay="0.6s"
                                >
                                  <Link
                                    to="/shop"
                                    className="th-btn style4 th-radius2"
                                  >
                                    <i className="fa-solid fa-cart-shopping me-2"></i>
                                    Shop Now
                                  </Link>
                                </div>
                              </div>
                            </div>

                            <div className="col-xl-5">
                              <div
                                className="hero-image"
                                data-ani="slideinup"
                                data-ani-delay="0.4s"
                              >
                                <img
                                  src="assets/img/image2.jpg"
                                  alt="img"
                                  className="hero-img-fluid"
                                />
                                {/* <div className="hero-img-bg-shape">
                                  <img
                                    // src="assets/img/hero/hero_shape_9_1.png"
                                     src="assets/img/image2.jpg" 
                                    alt="img"
                                  />
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                <button className="custom-prev">
                  <i className="fas fa-long-arrow-alt-left"></i>
                </button>
                <button className="custom-next">
                  <i className="fas fa-long-arrow-alt-right"></i>
                </button>
              </>
            </div>
            <div className="social-links">
              <Link to="https://www.instagram.com/shreejimedicalinstrument/">
                <i className="fab fa-instagram"></i>
              </Link>
              <Link
                to="https://www.google.com/search?q=Shreeji+Medical+Instrument+Sales+%26+Service&stick=H4sIAAAAAAAA_-NgU1I1qDC2NE21MDVLSzMzMExLTjG3MqiwME41SDE0NzQ2NrAwMEtKXcSqFZxRlJqalangm5qSmZyYo-CZV1xSVJqbmleiEJyYk1qsoKYQnFpUlpmcCgBlmDQtVgAAAA&hl=en-GB&mat=CZj-idQTNBWkElYBYJahadvTbgNOBBH5HW1MU06y9r9odX3imjI0NWI-9CbfJQa7sUcGnLDl5gJbZOQiigv041kUAYfNDnQeEN8kKDcHtyhwLxeSFpSK7u1waBCv2V8n4A&authuser=0
"
              >
                <i className="fab fa-google" />
              </Link>

              <Link to="https://www.facebook.com/people/Shreeji-Medical-Instrument-Sales-Service/61575696639548/">
                <i className="fab fa-facebook-f"></i>
              </Link>
            </div>
          </div>
          {/* Hero Section */}
          {/* Category Area   */}
          <div
            className="overflow-hidden overflow-category"
          >
            <div className="container">
              <div className="slider-area category-slider1">
                <div
                  // className="swiper th-slider"
                  className="ltn__slide-active-2 slick-slide-arrow-1 slick-slide-dots-1 mb-30"
                  id="catSlider1"
                  data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"476":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"4"},"1400":{"slidesPerView":"5"},"1700":{"slidesPerView":"6"}}}'
                >
                  <Swiper
                    modules={[Navigation, Pagination]}
                    pagination={{ clickable: true }}
                    loop={true}
                    slidesPerView={5} // 👈 20% each (5 items in a row)
                    spaceBetween={20} // 👈 gap between slides
                    className="mySwiper"
                   
                  >
                    <SwiperSlide>
                      <div className="category-card" data-theme-color="#F0F0F0" >
                        <div className="ltn__category-item-img" >
                          <i className="fas fa-notes-medical text-white"></i>
                        </div>
                        <h4 className="box-title text-white">
                          <Link to="/shop">Best Deals</Link>
                        </h4>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="category-card" data-theme-color="#EBF5DE">
                        <div className="ltn__category-item-img">
                          <i className="fas fa-box-tissue text-white"></i>
                        </div>
                        <h4 className="box-title text-white">
                          <Link to="/shop">Germs Pads</Link>
                        </h4>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="category-card" data-theme-color="#EBF5DE">
                        <div className="ltn__category-item-img">
                          <i className="fas fa-pump-medical text-white"></i>{" "}
                        </div>
                        <h4 className="box-title text-white">
                          <Link to="shop.html">Accessories</Link>
                        </h4>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="category-card" data-theme-color="#EBF5DE">
                        <div className="ltn__category-item-img">
                          <i className="fas fa-bong text-white"></i>{" "}
                        </div>
                        <h4 className="box-title text-white">
                          <Link to="shop.html">Medicine Cap</Link>
                        </h4>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="category-card" data-theme-color="#EBF5DE">
                        <div className="ltn__category-item-img">
                          <i className="fas fa-tooth text-white"></i>{" "}
                        </div>
                        <h4 className="box-title text-white">
                          <Link to="shop.html">Dental Item</Link>
                        </h4>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="category-card" data-theme-color="#EBF5DE">
                        <div className="ltn__category-item-img">
                          <i className="fas fa-syringe text-white"></i>{" "}
                        </div>
                        <h4 className="box-title text-white">
                          <Link to="shop.html">All Products</Link>
                        </h4>
                      </div>
                    </SwiperSlide>

                    {/* more slides... */}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
          {/* Product Details */}
          <section
            className="product-area overflow-hidden space overflow-hidden"
            id="project-sec"
          >
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div className="col-md-auto">
                  <h3 className="sec-title fw-medium text-anime-style-3">
                    Feature Medicine Products
                  </h3>
                </div>
              </div>
              <div
                className="swiper th-slider has-shadow"
                id="productSlider1"
                data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"768":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"1200":{"slidesPerView":"4"}}}'
              >
                <div className="swiper-wrapper feature-wrapper">
                  {products.slice(0, 4).map((product) => {
                    return (
                      <div className="swiper-slide feature-slide">
                        <div
                          className="th-product product-grid style2"
                          style={{ padding: "2px" }}
                        >
                          <div className="product-img">
                            <span className="category">Best For Rent</span>{" "}
                            <img
                              src={`https://sunrise-backend.sunrisemeditechsystems.com${product.image}`}
                              alt="Product Image1"
                            />
                            <div className="actions">
                              <Link
                                to="#"
                                className="icon-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(product.id, "cart");
                                }}
                              >
                                <i className="far fa-cart-plus"></i>
                              </Link>
                              <Link
                                to="#"
                                className="icon-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleAddToWishlist(product.id, "wishlist");
                                }}
                              >
                                <i className="far fa-heart"></i>
                              </Link>
                              <Link
                                to="#QuickView"
                                className="icon-btn popup-content"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(product.id, "quickview");
                                }}
                              >
                                <i className="far fa-eye"></i>
                              </Link>
                            </div>
                          </div>
                          <div className="product-content">
                            <div className="star-rating"></div>
                            <h3 className="product-title">
                              <Link
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(product.id, "quickview");
                                }}
                              >
                                {product.name}
                              </Link>
                            </h3>
                            <span className="price">₹ {product.salePrice}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* <div className="d-block d-md-none mt-40 text-center">
              <div className="icon-box">
                <button
                  data-slider-prev="#productSlider1"
                  className="slider-arrow default"
                >
                  <i className="far fa-arrow-left"></i>
                </button>
                <button
                  data-slider-next="#productSlider1"
                  className="slider-arrow default"
                >
                  <i className="far fa-arrow-right"></i>
                </button>
              </div>
            </div> */}
            </div>
          </section>

          <section
            className="product-area overflow-hidden space overflow-hidden"
            id="project-sec"
          >
            <div className="container">
              {/* <div className="row justify-content-between align-items-center"> */}
              <div class="row gy-50">
                <div class="col-xl-3 col-lg-4 col-md-6">
                  <div class="product-add-wrap">
                    <img src="assets/img/medicine-product.jpg" alt="img" />
                  </div>
                </div>
                <div class="col-xl-9 col-lg-8 col-md-6">
                  <div class="row justify-content-between align-items-center">
                    <div className="col-md-auto">
                      <h3 className="sec-title fw-medium text-anime-style-3">
                        Trending Products
                      </h3>
                    </div>
                    {/* </div> */}
                    <div class="col-auto">
                      <div class="sec-btn mb-50">
                        <Link
                          class="th-btn btn-sm black-border th-radius2"
                          to="/shop"
                        >
                          See All Products
                          <i class="far fa-long-arrow-right ms-2"></i>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div
                    className="swiper th-slider has-shadow"
                    id="productSlider1"
                    data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"768":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"1200":{"slidesPerView":"4"}}}'
                  >
                    <div className="swiper-wrapper feature-wrapper">
                      {products.slice(4, 8).map((product) => {
                        return (
                          <div className="swiper-slide feature-slide">
                            <div
                              className="th-product product-grid style2"
                              style={{ padding: "2px" }}
                            >
                              <div className="product-img">
                                <span className="category">Best For Rent</span>{" "}
                                <img
                                  src={`https://sunrise-backend.sunrisemeditechsystems.com${product.image}`}
                                  alt="Product Image4"
                                />
                                <div className="actions">
                                  <Link
                                    to="cart.html"
                                    className="icon-btn"
                                    alt="cart1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleProductClick(product.id);
                                    }}
                                  >
                                    <i className="far fa-cart-plus"></i>
                                  </Link>
                                  <Link
                                    to="wishlist.html"
                                    className="icon-btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleAddToWishlist(
                                        product.id,
                                        "wishlist"
                                      );
                                    }}
                                  >
                                    <i className="far fa-heart"></i>
                                  </Link>
                                  <Link
                                    to="#QuickView"
                                    className="icon-btn popup-content"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleProductClick(product.id);
                                    }}
                                  >
                                    <i className="far fa-eye"></i>
                                  </Link>
                                </div>
                              </div>
                              <div className="product-content">
                                <div className="star-rating"></div>
                                <h3 className="product-title">
                                  <Link
                                    to="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleProductClick(product.id);
                                    }}
                                  >
                                    {product.name}
                                  </Link>
                                </h3>
                                <span className="price">
                                  ₹ {product.salePrice}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="cta-sec4 space-top overflow-hidden" id="about-sec">
            <div class="container">
              <div class="row gy-4 justify-content-between">
                <div class="col-xl-6">
                  <div
                    class="cta-card4"
                    data-bg-src="assets/img/card-bg1.jpg"
                    style={{
                      backgroundImage: `url("assets/img/card-bg1.jpg")`,
                    }}
                  >
                    <span class="box-subtitle text-white text-anime-style-3">
                      Medicine
                    </span>
                    <h3 class="box-title text-white text-anime-style-3">
                      Painkiller <br />
                      Medicine Tablet
                    </h3>
                    <Link to="/shop" class="th-btn btn-sm2 style5 th-radius2">
                      <i class="fas fa-shopping-cart me-2"></i>Shop Now
                    </Link>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div
                    class="cta-card4"
                    data-bg-src="assets/img/cta-card-bg2.jpg"
                    style={{
                      backgroundImage: `url("assets/img/cta-card-bg2.jpg")`,
                    }}
                  >
                    <span class="box-subtitle text-anime-style-3">
                      Medicine
                    </span>
                    <h3 class="box-title text-anime-style-3">
                      Allergy medication <br />
                      Medicine Tablet
                    </h3>
                    <Link to="/shop" class="th-btn btn-sm2 style4 th-radius2">
                      <i class="fas fa-shopping-cart me-2"></i>Shop Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="product-area overflow-hidden space overflow-hidden"
            id="project-sec"
            style={{ marginBottom: "70px" }}
          >
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div className="col-md-auto">
                  <h3 className="sec-title fw-medium text-anime-style-3">
                    Best Selling Item
                  </h3>
                </div>
                {/* <div className="col-auto">
                  <div className="sec-btn mb-50">
                    <div className="icon-box">
                      <button
                        data-slider-prev="#productSlider1"
                        className="slider-arrow style2 style-sm default"
                      >
                        <i className="far fa-long-arrow-left"></i>
                      </button>
                      <button
                        data-slider-next="#productSlider1"
                        className="slider-arrow style2 style-sm default"
                      >
                        <i className="far fa-long-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
              <div
                className="swiper th-slider has-shadow"
                id="productSlider1"
                data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"768":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"1200":{"slidesPerView":"4"}}}'
              >
                <div className="swiper-wrapper feature-wrapper">
                  {products.slice(8, 12).map((product) => {
                    return (
                      <div className="swiper-slide feature-slide">
                        <div
                          className="th-product product-grid style2"
                          style={{ padding: "2px" }}
                        >
                          <div className="product-img">
                            <span className="category">Best For Rent</span>
                            <img
                              src={`https://sunrise-backend.sunrisemeditechsystems.com${product.image}`}
                              alt="Product Image4"
                            />
                            <div className="actions">
                              <Link
                                to="cart.html"
                                className="icon-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(product.id);
                                }}
                              >
                                <i className="far fa-cart-plus"></i>
                              </Link>
                              <Link
                                to="wishlist.html"
                                className="icon-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleAddToWishlist(product.id, "wishlist");
                                }}
                              >
                                <i className="far fa-heart"></i>
                              </Link>
                              <Link
                                to="#QuickView"
                                className="icon-btn popup-content"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(product.id);
                                }}
                              >
                                <i className="far fa-eye"></i>
                              </Link>
                            </div>
                          </div>
                          <div className="product-content">
                            <div className="star-rating"></div>
                            <h3 className="product-title">
                              <Link
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleProductClick(product.id);
                                }}
                              >
                                {product.name}
                              </Link>
                            </h3>
                            <span className="price">₹ {product.salePrice}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* <div className="d-block d-md-none mt-40 text-center">
              <div className="icon-box">
                <button
                  data-slider-prev="#productSlider1"
                  className="slider-arrow default"
                >
                  <i className="far fa-arrow-left"></i>
                </button>
                <button
                  data-slider-next="#productSlider1"
                  className="slider-arrow default"
                >
                  <i className="far fa-arrow-right"></i>
                </button>
              </div>
            </div> */}
            </div>
          </section>
          <div
            className="ltn__about-us-area bg-image pt-115 pb-110"
            style={{ backgroundImage: `url('img/bg/26.jpg')` }}
          >
            <div className="container-fluid" style={{ padding: "0 6%" }}>
              <div className="row">
                <div className="col-lg-12 align-self-center">
                  <div className="about-us-img-wrap about-img-left">                    
                  </div>
                </div>
                <div className="col-lg-8 align-self-center">
                  <div className="about-us-info-wrap">
                    <div className="section-title-area ltn__section-title-2--- mb-20">
                      <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                        N95 Facial Covering Mask
                      </h6>
                      <h1 className="section-title">
                        Grade A Safety Masks For Sale. Hurry Up!
                      </h1>
                      <p>
                        Over 39,000 people work for us in more than 70 countries
                        all over the This breadth of global coverage, combined
                        with specialist services
                      </p>
                    </div>
                    <ul className="ltn__list-item-half clearfix">
                      <li>
                        <i className="fas fa-home"></i>
                        Activated Carbon
                      </li>
                      <li>
                        <i className="fas fa-mountain"></i>
                        Breathing Valve
                      </li>
                      <li>
                        <i className="fas fa-heart" />6 Layer Filteration
                      </li>
                      <li>
                        <i className="fas fa-shield-alt" />
                        Rewashes &amp; Reusable
                      </li>
                    </ul>
                    <div className="btn-wrapper animated">
                      <Link
                        to="/shop"
                        className="ltn__secondary-color text-uppercase text-decoration-underline"
                      >
                        View Products
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>         
          <div className="overflow-hidden space-bottom overflow-hidden">
            <div className="container">
              <div className="text-center">
                <span className="patient-feedback">
                  <span className="title">Our Feedback 4.98 </span>
                  <span className="box-review">
                    <i className="fa-sharp fa-solid fa-star"></i>
                    <i className="fa-sharp fa-solid fa-star"></i>
                    <i className="fa-sharp fa-solid fa-star"></i>
                    <i className="fa-sharp fa-solid fa-star"></i>
                    <i className="fa-sharp fa-solid fa-star"></i>
                  </span>
                  Based on(29k Reviews)
                </span>
              </div>
              <div className="slider-area">
                <div
                  className="swiper th-slider"
                  id="brandSlider1"
                  data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"476":{"slidesPerView":"2"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"4"},"1400":{"slidesPerView":"5"}}}'
                >
                  <div className="swiper-wrapper feature-wrapper">
                    <div className="swiper-slide brand-logo">
                      <div className="brand-item">
                        <Link to="">
                          <img
                            className="original"
                            src="assets/img/brand/brand_5_2.svg"
                            alt="Brand Logo"
                          />
                          <img
                            className="gray"
                            src="assets/img/brand/brand_5_2.svg"
                            alt="Brand Logo"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="swiper-slide brand-logo">
                      <div className="brand-item">
                        <Link to="">
                          <img
                            className="original"
                            src="assets/img/brand/brand_5_3.svg"
                            alt="Brand Logo"
                          />
                          <img
                            className="gray"
                            src="assets/img/brand/brand_5_3.svg"
                            alt="Brand Logo"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="swiper-slide brand-logo">
                      <div className="brand-item">
                        <Link to="">
                          <img
                            className="original"
                            src="assets/img/brand/brand_5_4.svg"
                            alt="Brand Logo"
                          />
                          <img
                            className="gray"
                            src="assets/img/brand/brand_5_4.svg"
                            alt="Brand Logo"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="swiper-slide brand-logo">
                      <div className="brand-item">
                        <Link to="">
                          <img
                            className="original"
                            src="assets/img/brand/brand_5_5.svg"
                            alt="Brand Logo"
                          />
                          <img
                            className="gray"
                            src="assets/img/brand/brand_5_5.svg"
                            alt="Brand Logo"
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="swiper-slide brand-logo">
                      <div className="brand-item">
                        <Link to="">
                          <img
                            className="original"
                            src="assets/img/brand/brand_5_3.svg"
                            alt="Brand Logo"
                          />
                          <img
                            className="gray"
                            src="assets/img/brand/brand_5_3.svg"
                            alt="Brand Logo"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
        {/* Footer Area */}
      </Layout>
      {/* </div> */}
    </>
  );
}
